const REQUEST_URLS = {
    GLOBAL: {
        GET_USER_POSTS: "/api/v1/Providers/Divar/getMyPosts"
    },
    INTEGRATED_AUTHENTICATION: {
        CREATE_PAYMENT: "/api/v1/Providers/integratedAuthentication/GetPecPaymentOrderId",
        SHAHKAR: "/api/v1/Fronts/integratedAuthentication/Shahkar",
        COMPARE_FACES: "/api/v1/Fronts/integratedAuthentication/CompareFaces",
        PAYMENT_INQUIRY: "/api/v1/Providers/integratedAuthentication/PaymentInquiry",
        RESET_PROCESS: "/api/v1/Providers/integratedAuthentication/reset",
        FETCH_PROCESS: "/api/v1/Providers/integratedAuthentication/FetchProcess",
        CREATE_PROCESS: "/api/v1/Providers/integratedAuthentication",
        VIDEO_VALIDATION: "/api/v1/Fronts/integratedAuthentication/VideoValidation",
        CONFIRM_IMG: "/api/v1/Providers/integratedAuthentication/ConfirmWidget",
        NID_CARD_READER: "/api/v1/Fronts/integratedAuthentication/NIDCardReader",
        DELETE_WIDGET: "/api/v1/Providers/integratedAuthentication/DeleteWidget",
    },
    AUTHENTICATION: {
        GET_LADDER_PRICE:"/api/v1/Providers/Categories/Authentication/Nardeban/GetAdPrice",
        DISCOUNT_PRE_CONFIRM: "/api/v1/Providers/Categories/Authentication/Discount",
        REMOVE_DISCOUNT: "/api/v1/Providers/Categories/Authentication/Discount",
        PAYMENT_INQUIRY: "/api/v1/Providers/Categories/Authentication/Payments/InquiryPayment",
        CREATE_PROCESS: "/api/v1/Providers/Categories/Authentication/CreateProcess",
        INQUIRY_PROCESS: "/api/v1/Providers/Categories/Authentication/InquiryProcess",
        FETCH_PROCESS: "/api/v1/Providers/Categories/Authentication/FetchProcess",
        SHAHKAR: "/api/v1/Fronts/Categories/Authentication/Shahkar",
        AUTO_I_AUTH: "/api/v1/Providers/Categories/Authentication/AutoIAuth",
        AUTO_NID_CARD: "/api/v1/Fronts/Categories/Authentication/AutoNIDCard",
        SKIP_STEP: "/api/v1/Providers/Categories/Authentication/SkipStep",
        RESET_PROCESS: "/api/v1/Providers/Categories/Authentication/ResetProcess",
        LAWYER_INQUIRY: "/api/v1/Fronts/Categories/Authentication/LawyerInquiry",
        POLICE_CLEARANCE_INQUIRY: "/api/v1/Fronts/Categories/Authentication/PoliceClearanceInquiry",
        EXPERT_INQUIRY: "/api/v1/Fronts/Categories/Authentication/ExpertInquiry",
        DELETE_WIDGET: "/api/v1/Providers/Categories/Authentication/DeleteWidget",
        GET_ITEMS: "/api/v1/Providers/Categories/Authentication/GetItems",
        SET_ITEMS: "/api/v1/Providers/Categories/Authentication/SetItems",
        INIT_CONFIRM: "/api/v1/Providers/Categories/Authentication/InitConfirm",
        CREATE_PAYMENT: "/api/v1/Providers/Categories/Authentication/Payments/CreatePayment",
        LOGIN_BUSINESS_LICENSE: "/api/v1/Fronts/Categories/Authentication/LoginBusinessLicense",
        VERIFY_BUSINESS_LICENSE_OTP: "/api/v1/Fronts/Categories/Authentication/VerifyBusinessLicenseOTP",
        PASSWORD_BUSINESS_LICENSE: "/api/v1/Fronts/Categories/Authentication/PasswordBusinessLicense",
        BUSINESS_LICENSE_INQUIRY: "/api/v1/Fronts/Categories/Authentication/BusinessLicenseInquiry",
        NID_CARD_READER: "/api/v1/Fronts/Categories/Authentication/NIDCardReader",
        CONFIRM_IMG_WIDGET: "/api/v1/Providers/Categories/Authentication/ConfirmImgWidget",
        COMPARE_FACES: "/api/v1/Fronts/Categories/Authentication/CompareFaces",
        VIDEO_VALIDATION: "/api/v1/Fronts/Categories/Authentication/VideoValidation",
        MANAGE_I_AUTH: '/api/v1/Providers/Categories/Authentication/ManageIAuth',
        CONFIRM_BUSINESS: '/api/v1/Providers/Categories/Authentication/ConfirmBusiness'
    },
    CAR_SERVICES: {
        PAYMENT_INQUIRY: "/api/v1/Providers/CarServices/PaymentInquiry",
        FETCH_PROCESS: "/api/v1/Providers/CarServices/FetchProcess",
        CREATE_PROCESS: "/api/v1/Providers/CarServices",
        INIT_CONFIRM: "/api/v1/Providers/CarServices",
        GET_PEC_PAYMENT_ORDER_ID: "/api/v1/Providers/CarServices/GetPecPaymentOrderId",
        CAR_CARD_INQUIRY: "/api/v1/Fronts/CarServices/CarCardInquiry",
        SKIP_INSURANCE: "/api/v1/Providers/CarServices/SkipInsuranceInquiry",
        INSURANCE_INQUIRY: '/api/v1/Fronts/CarServices/InsuranceInquiry',
        SKIP_TECHNICAL_INSPECTION_INQUIRY: "/api/v1/Providers/CarServices/SkipCarTechnicalInspectionInquiry",
        CAR_MODEL_INQUIRY: "/api/v1/Fronts/CarServices/CarModelInquiry",
        CAR_TECHNICAL_INSPECTION_INQUIRY: "/api/v1/Fronts/CarServices/CarTechnicalInspectionInquiry",
        RESET_STEP: "/api/v1/Providers/CarServices/reset",
        CAR_CARD_READER: "/api/v1/Fronts/CarServices/CarCardReader",
        INQUIRY_PROCESS: '/api/v1/Providers/CarServices/InquiryProcess',
        DELETE_WIDGET: '/api/v1/Providers/CarServices/DeleteWidget',
        REQUEST_OTP: '/api/v1/Providers/CarServices/RequestOTP',
        CONFIRM_OTP: '/api/v1/Providers/CarServices/ConfirmOTP',
        SHAHKAR:"/api/v1/Fronts/CarServices/Shahkar",
        DISCOUNT:"/api/v1/Providers/CarServices/Discount"
    },
    ESTATE: {
        PAYMENT_INQUIRY: "/api/v1/Providers/Estate/PaymentInquiry",
        CREATE_PROCESS: "/api/v1/Providers/Estate",
        FETCH_PROCESS: "/api/v1/Providers/Estate/FetchProcess",
        SHAHKAR: "/api/v1/Fronts/Estate/Shahkar",
        SKIP_SHAHKAR: "/api/v1/Providers/Estate/skipShahkar",
        ESTATE_INQUIRY: "/api/v1/Fronts/Estate/EstateInquiry",
        RESET: "/api/v1/Providers/Estate/reset",
        CREATE_PAYMENT: "/api/v1/Providers/Estate/GetPecPaymentOrderId",
        INIT_CONFIRM: "/api/v1/Providers/Estate",
        DELETE_WIDGET: "/api/v1/Providers/Estate/DeleteWidget",
        REPORT: "/api/v1/Providers/Reports/Create",
        INQUIRY_PROCESS: "/api/v1/Providers/Estate/InquiryProcess",
        REQUEST_OTP: "/api/v1/Providers/Estate/RequestOTP",
        CONFIRM_OTP: "/api/v1/Providers/Estate/ConfirmOTP",
        DISCOUNT: "/api/v1/Providers/Estate/Discount",

    },
    COMPANY_APPROVAL:{
      CREATE_PROCESS:"/api/v1/Providers/CompanyApproval/CreateProcess",
      SHAHKAR:"/api/v1/Fronts/CompanyApproval/Shahkar",
      FETCH_PROCESS:"/api/v1/Providers/CompanyApproval/FetchProcess",
      INQUIRY_PROCESS:"/api/v1/Providers/CompanyApproval/InquiryProcess",
      CREATE_PAYMENT:"/api/v1/Providers/CompanyApproval/Payments/CreatePayment",
      PAYMENT_INQUIRY:"/api/v1/Providers/CompanyApproval/Payments/InquiryPayment",
      INIT_CONFIRM:"/api/v1/Providers/CompanyApproval/InitConfirm",
      REQUEST_OTP:"/api/v1/Providers/CompanyApproval/RequestOTP",
      VERIFY_OTP: "/api/v1/Providers/CompanyApproval/ConfirmOTP",
      RESET_PROCESS:"/api/v1/Providers/CompanyApproval/ResetProcess",
      DELETE_WIDGET:"/api/v1/Providers/CompanyApproval/DeleteWidget",
      BUSINESS_LICENSE_INQUIRY: "/api/v1/Fronts/CompanyApproval/CompanyBusinessLicenseInquiry",
      CONFIRM_BUSINESS: '/api/v1/Providers/CompanyApproval/ConfirmBusiness',
      DISCOUNT:"/api/v1/Providers/CompanyApproval/Discount",

    },
    DIVAR_INTERNAL_ESTATE: {
        CREATE_PROCESS: "/api/v1/Providers/DivarInternalEstate/CreateProcess",
        FETCH_PROCESS: "/api/v1/Providers/DivarInternalEstate/FetchProcess",
        SHAHKAR: "/api/v1/Fronts/DivarInternalEstate/Shahkar",
        SKIP_SHAHKAR: "/api/v1/Providers/DivarInternalEstate/SkipShahkar",
        RESET: "/api/v1/Providers/DivarInternalEstate/ResetProcess",
        INIT_CONFIRM: "/api/v1/Providers/DivarInternalEstate/InitConfirm",
        INQUIRY_PROCESS: "/api/v1/Providers/DivarInternalEstate/InquiryProcess",
        REQUEST_OTP: "/api/v1/Providers/DivarInternalEstate/RequestOTP",
        CONFIRM_OTP: "/api/v1/Providers/DivarInternalEstate/ConfirmOTP",
        ESTATE_INQUIRY: "/api/v1/Fronts/DivarInternalEstate/EstateInquiry",

    },
    ORIGINALITY_DEVICE: {
        PAYMENT_INQUIRY: "/api/v1/Providers/OriginalityDevice/Payments/InquiryPayment",
        CREATE_PROCESS: "/api/v1/Providers/OriginalityDevice/CreateProcess",
        FETCH_PROCESS: '/api/v1/Providers/OriginalityDevice/FetchProcess',
        SHAHKAR: "/api/v1/Fronts/OriginalityDevice/Shahkar",
        INQUIRY_PROCESS: "/api/v1/Providers/OriginalityDevice/InquiryProcess",
        SKIP_STEP: "/api/v1/Providers/Categories/Hamta/SkipStep",
        IMEI_INQUIRY: "/api/v1/Fronts/OriginalityDevice/IMEIInquiry",
        REST_PROCESS: "/api/v1/Providers/OriginalityDevice/ResetProcess",
        INIT_CONFIRM: "/api/v1/Providers/OriginalityDevice/InitConfirm",
        CREATE_PAYMENT: "/api/v1/Providers/OriginalityDevice/Payments/CreatePayment",
        DELETE_WIDGET: "/api/v1/Providers/OriginalityDevice/DeleteWidget"
    },
    TRANSACTIONAL_CREDIT: {
        PAYMENT_INQUIRY: "/api/v1/Providers/TransactionalCredit/Ads/Payments/InquiryPayment",
        CREATE_PROCESS: "/api/v1/Providers/TransactionalCredit/Ads/CreateProcess",
        FETCH_PROCESS: '/api/v1/Providers/TransactionalCredit/Ads/FetchProcess',
        SHAHKAR: "/api/v1/Fronts/TransactionalCredit/Ads/Shahkar",
        INQUIRY_PROCESS: "/api/v1/Providers/TransactionalCredit/Ads/InquiryProcess",
        REST_PROCESS: "/api/v1/Providers/TransactionalCredit/Ads/ResetProcess",
        INIT_CONFIRM: "/api/v1/Providers/TransactionalCredit/Ads/InitConfirm",
        CREATE_PAYMENT: "/api/v1/Providers/TransactionalCredit/Ads/Payments/CreatePayment",
        DELETE_WIDGET: "/api/v1/Providers/TransactionalCredit/Ads/DeleteWidget",
        REQUEST_OTP: "/api/v1/Fronts/TransactionalCredit/Ads/RequestOTP",
        VERIFY_OTP: "/api/v1/Fronts/TransactionalCredit/Ads/VerifyOTP",
    },
    FIN_CHECK: {
        INQUIRY_PROCESS: "/api/v1/Providers/FinCheck/InquiryProcess",
        CREATE_PROCESS: "/api/v1/Providers/FinCheck/CreateProcess",
        FETCH_PROCESS: "/api/v1/Providers/FinCheck/FetchProcess",
        INIT_CONFIRM: "/api/v1/Providers/FinCheck/InitConfirm",
        CREATE_PAYMENT: "/api/v1/Providers/FinCheck/Payments/CreatePayment",
        PAYMENT_INQUIRY: "/api/v1/Providers/FinCheck/Payments/InquiryPayment",
        SHAHKAR: "/api/v1/Fronts/FinCheck/Shahkar",
        BANKING_OTP_SEND:"/api/v1/Fronts/FinCheck/BankingOTPSend",
        BANKING_OTP_VERIFY:"/api/v1/Fronts/FinCheck/BankingOTPVerify",
        BACK_CHEQUES_INQUIRY:"/api/v1/Fronts/FinCheck/BackChequesInquiry",
        FACILITY_INQUIRY:"/api/v1/Fronts/FinCheck/FacilityInquiry",
        RESET_PROCESS:"/api/v1/Providers/FinCheck/ResetProcess",
        DELETE_WIDGET:"/api/v1/Providers/FinCheck/DeleteWidget",
        DISCOUNT:"/api/v1/Providers/FinCheck/Discount",

    },
    DIVAR_INTERNAL_CAR: {
        FETCH_PROCESS: "/api/v1/Providers/DivarInternalCar/FetchProcess",
        SHAHKAR: "/api/v1/Fronts/DivarInternalCar/Shahkar",
        CREATE_PROCESS: "/api/v1/Providers/DivarInternalCar/CreateProcess",
        INQUIRY_PROCESS: "/api/v1/Providers/DivarInternalCar/InquiryProcess",
        INIT_CONFIRM: "/api/v1/Providers/DivarInternalCar/InitConfirm",
        CAR_MODEL_INQUIRY: "/api/v1/Fronts/DivarInternalCar/CarModelInquiry",
        RESET_PROCESS: "/api/v1/Providers/DivarInternalCar/ResetProcess",
        CAR_CARD_INQUIRY: "/api/v1/Fronts/DivarInternalCar/CarCardInquiry",
        REQUEST_OTP:"/api/v1/Providers/DivarInternalCar/RequestOTP",
        CONFIRM_OTP:"/api/v1/Providers/DivarInternalCar/ConfirmOTP"
    },
    DIVAR_INTERNAL_AUTH: {
        CREATE_PROCESS: "/api/v1/Providers/DivarInternalAuth/CreateProcess",
        INQUIRY_PROCESS: "/api/v1/Providers/DivarInternalAuth/InquiryProcess",
        RESET_PROCESS: "/api/v1/Providers/DivarInternalAuth/ResetProcess",
        FETCH_PROCESS: "/api/v1/Providers/DivarInternalAuth/FetchProcess",
        AUTO_NID_CARD: "/api/v1/Fronts/DivarInternalAuth/AutoNIDCard",
        SHAHKAR: "/api/v1/Fronts/DivarInternalAuth/Shahkar",
        COMPARE_FACES: "/api/v1/Fronts/DivarInternalAuth/CompareFaces",
        NID_CARD_READER: "/api/v1/Fronts/DivarInternalAuth/NIDCardReader",
        INIT_CONFIRM: "/api/v1/Providers/DivarInternalAuth/InitConfirm",
        VIDEO_VALIDATION: "/api/v1/Fronts/DivarInternalAuth/VideoValidation",
        CREATE_PAYMENT: "/api/v1/Providers/DivarInternalAuth/Payments/CreatePayment",
        INQUIRY_PAYMENT: "/api/v1/Providers/DivarInternalAuth/Payments/InquiryPayment"
    },
    DIVAR_FOREIGNER_AUTH: {
        CREATE_PROCESS: "/api/v1/Providers/ForeignerAuth/CreateProcess",
        INQUIRY_PROCESS: "/api/v1/Providers/ForeignerAuth/InquiryProcess",
        FETCH_PROCESS: "/api/v1/Providers/ForeignerAuth/FetchProcess",
        VIDEO_VALIDATION: "/api/v1/Fronts/ForeignerAuth/UniqueFace",
        FOREIGNER_DOCUMENT_READER: "/api/v1/Fronts/ForeignerAuth/ForeignDocumentReader"
    }

}
const ENCRYPTION_URL_LIST = [
    //---------------GLOBAL------------------------------
    REQUEST_URLS.GLOBAL.GET_USER_POSTS,
    //---------------AUTHENTICATION ---------------------
    REQUEST_URLS.AUTHENTICATION.CREATE_PROCESS,
    REQUEST_URLS.AUTHENTICATION.INQUIRY_PROCESS,
    REQUEST_URLS.AUTHENTICATION.FETCH_PROCESS,
    REQUEST_URLS.AUTHENTICATION.SHAHKAR,
    REQUEST_URLS.AUTHENTICATION.AUTO_I_AUTH,
    REQUEST_URLS.AUTHENTICATION.AUTO_NID_CARD,
    REQUEST_URLS.AUTHENTICATION.SKIP_STEP,
    REQUEST_URLS.AUTHENTICATION.RESET_PROCESS,
    REQUEST_URLS.AUTHENTICATION.LAWYER_INQUIRY,
    REQUEST_URLS.AUTHENTICATION.POLICE_CLEARANCE_INQUIRY,
    REQUEST_URLS.AUTHENTICATION.DELETE_WIDGET,
    REQUEST_URLS.AUTHENTICATION.GET_ITEMS,
    REQUEST_URLS.AUTHENTICATION.SET_ITEMS,
    REQUEST_URLS.AUTHENTICATION.INIT_CONFIRM,
    REQUEST_URLS.AUTHENTICATION.CREATE_PAYMENT,
    REQUEST_URLS.AUTHENTICATION.LOGIN_BUSINESS_LICENSE,
    REQUEST_URLS.AUTHENTICATION.VERIFY_BUSINESS_LICENSE_OTP,
    REQUEST_URLS.AUTHENTICATION.PASSWORD_BUSINESS_LICENSE,
    REQUEST_URLS.AUTHENTICATION.BUSINESS_LICENSE_INQUIRY,
    REQUEST_URLS.AUTHENTICATION.NID_CARD_READER,
    REQUEST_URLS.AUTHENTICATION.CONFIRM_IMG_WIDGET,
    REQUEST_URLS.AUTHENTICATION.COMPARE_FACES,
    REQUEST_URLS.AUTHENTICATION.VIDEO_VALIDATION,
    REQUEST_URLS.AUTHENTICATION.MANAGE_I_AUTH,
    REQUEST_URLS.AUTHENTICATION.PAYMENT_INQUIRY,
    REQUEST_URLS.AUTHENTICATION.CONFIRM_BUSINESS,
    REQUEST_URLS.AUTHENTICATION.DISCOUNT_PRE_CONFIRM,
    REQUEST_URLS.AUTHENTICATION.REMOVE_DISCOUNT,
    REQUEST_URLS.AUTHENTICATION.GET_LADDER_PRICE,


    //---------------CAR SERVICES---------------------
    REQUEST_URLS.CAR_SERVICES.FETCH_PROCESS,
    REQUEST_URLS.CAR_SERVICES.CREATE_PROCESS,
    REQUEST_URLS.CAR_SERVICES.INIT_CONFIRM,
    REQUEST_URLS.CAR_SERVICES.GET_PEC_PAYMENT_ORDER_ID,
    REQUEST_URLS.CAR_SERVICES.CAR_CARD_INQUIRY,
    REQUEST_URLS.CAR_SERVICES.SKIP_INSURANCE,
    REQUEST_URLS.CAR_SERVICES.INSURANCE_INQUIRY,
    REQUEST_URLS.CAR_SERVICES.SKIP_TECHNICAL_INSPECTION_INQUIRY,
    REQUEST_URLS.CAR_SERVICES.CAR_MODEL_INQUIRY,
    REQUEST_URLS.CAR_SERVICES.CAR_TECHNICAL_INSPECTION_INQUIRY,
    REQUEST_URLS.CAR_SERVICES.RESET_STEP,
    REQUEST_URLS.CAR_SERVICES.CAR_CARD_READER,
    REQUEST_URLS.CAR_SERVICES.INQUIRY_PROCESS,
    REQUEST_URLS.CAR_SERVICES.DELETE_WIDGET,
    REQUEST_URLS.CAR_SERVICES.PAYMENT_INQUIRY,
    REQUEST_URLS.CAR_SERVICES.REQUEST_OTP,
    REQUEST_URLS.CAR_SERVICES.CONFIRM_OTP,
    REQUEST_URLS.CAR_SERVICES.SHAHKAR,
    REQUEST_URLS.CAR_SERVICES.DISCOUNT,

    //---------------ESTATES--------------------
    REQUEST_URLS.ESTATE.PAYMENT_INQUIRY,
    REQUEST_URLS.ESTATE.CREATE_PROCESS,
    REQUEST_URLS.ESTATE.FETCH_PROCESS,
    REQUEST_URLS.ESTATE.RESET,
    REQUEST_URLS.ESTATE.SHAHKAR,
    REQUEST_URLS.ESTATE.SKIP_SHAHKAR,
    REQUEST_URLS.ESTATE.ESTATE_INQUIRY,
    REQUEST_URLS.ESTATE.CREATE_PAYMENT,
    REQUEST_URLS.ESTATE.INIT_CONFIRM,
    REQUEST_URLS.ESTATE.DELETE_WIDGET,
    REQUEST_URLS.ESTATE.INQUIRY_PROCESS,
    REQUEST_URLS.ESTATE.REQUEST_OTP,
    REQUEST_URLS.ESTATE.CONFIRM_OTP,
    REQUEST_URLS.ESTATE.DISCOUNT,
    //------DIVAR INTERNAL ESTATE---------------------
    REQUEST_URLS.DIVAR_INTERNAL_ESTATE.CREATE_PROCESS,
    REQUEST_URLS.DIVAR_INTERNAL_ESTATE.FETCH_PROCESS,
    REQUEST_URLS.DIVAR_INTERNAL_ESTATE.RESET,
    REQUEST_URLS.DIVAR_INTERNAL_ESTATE.SHAHKAR,
    REQUEST_URLS.DIVAR_INTERNAL_ESTATE.SKIP_SHAHKAR,
    REQUEST_URLS.DIVAR_INTERNAL_ESTATE.ESTATE_INQUIRY,
    REQUEST_URLS.DIVAR_INTERNAL_ESTATE.INIT_CONFIRM,
    REQUEST_URLS.DIVAR_INTERNAL_ESTATE.INQUIRY_PROCESS,
    REQUEST_URLS.DIVAR_INTERNAL_ESTATE.REQUEST_OTP,
    REQUEST_URLS.DIVAR_INTERNAL_ESTATE.CONFIRM_OTP,

    //------------ORIGINALITY DEVICE----------------
    REQUEST_URLS.ORIGINALITY_DEVICE.REST_PROCESS,
    REQUEST_URLS.ORIGINALITY_DEVICE.SHAHKAR,
    REQUEST_URLS.ORIGINALITY_DEVICE.FETCH_PROCESS,
    REQUEST_URLS.ORIGINALITY_DEVICE.IMEI_INQUIRY,
    REQUEST_URLS.ORIGINALITY_DEVICE.CREATE_PROCESS,
    REQUEST_URLS.ORIGINALITY_DEVICE.INQUIRY_PROCESS,
    REQUEST_URLS.ORIGINALITY_DEVICE.REST_PROCESS,
    REQUEST_URLS.ORIGINALITY_DEVICE.INIT_CONFIRM,
    REQUEST_URLS.ORIGINALITY_DEVICE.CREATE_PAYMENT,
    REQUEST_URLS.ORIGINALITY_DEVICE.DELETE_WIDGET,
    REQUEST_URLS.ORIGINALITY_DEVICE.PAYMENT_INQUIRY,

    //----------TRANSACTIONAL CREDIT ---------------
    REQUEST_URLS.TRANSACTIONAL_CREDIT.CREATE_PROCESS,
    REQUEST_URLS.TRANSACTIONAL_CREDIT.FETCH_PROCESS,
    REQUEST_URLS.TRANSACTIONAL_CREDIT.SHAHKAR,
    REQUEST_URLS.TRANSACTIONAL_CREDIT.INQUIRY_PROCESS,
    REQUEST_URLS.TRANSACTIONAL_CREDIT.SKIP_STEP,
    REQUEST_URLS.TRANSACTIONAL_CREDIT.REST_PROCESS,
    REQUEST_URLS.TRANSACTIONAL_CREDIT.INIT_CONFIRM,
    REQUEST_URLS.TRANSACTIONAL_CREDIT.PAYMENT_INQUIRY,
    REQUEST_URLS.TRANSACTIONAL_CREDIT.CREATE_PAYMENT,
    REQUEST_URLS.TRANSACTIONAL_CREDIT.DELETE_WIDGET,
    REQUEST_URLS.TRANSACTIONAL_CREDIT.VERIFY_OTP,
    REQUEST_URLS.TRANSACTIONAL_CREDIT.REQUEST_OTP,

    //----------Divar Internal Car --------------------
    REQUEST_URLS.DIVAR_INTERNAL_CAR.FETCH_PROCESS,
    REQUEST_URLS.DIVAR_INTERNAL_CAR.SHAHKAR,
    REQUEST_URLS.DIVAR_INTERNAL_CAR.CREATE_PROCESS,
    REQUEST_URLS.DIVAR_INTERNAL_CAR.INQUIRY_PROCESS,
    REQUEST_URLS.DIVAR_INTERNAL_CAR.INIT_CONFIRM,
    REQUEST_URLS.DIVAR_INTERNAL_CAR.CAR_MODEL_INQUIRY,
    REQUEST_URLS.DIVAR_INTERNAL_CAR.RESET_PROCESS,
    REQUEST_URLS.DIVAR_INTERNAL_CAR.CAR_CARD_INQUIRY,
    REQUEST_URLS.DIVAR_INTERNAL_CAR.REQUEST_OTP,
    REQUEST_URLS.DIVAR_INTERNAL_CAR.CONFIRM_OTP,


    //---------Divar Internal Auth --------------------

    REQUEST_URLS.DIVAR_INTERNAL_AUTH.CREATE_PROCESS,
    REQUEST_URLS.DIVAR_INTERNAL_AUTH.INQUIRY_PROCESS,
    REQUEST_URLS.DIVAR_INTERNAL_AUTH.RESET_PROCESS,
    REQUEST_URLS.DIVAR_INTERNAL_AUTH.FETCH_PROCESS,
    REQUEST_URLS.DIVAR_INTERNAL_AUTH.AUTO_NID_CARD,
    REQUEST_URLS.DIVAR_INTERNAL_AUTH.SHAHKAR,
    REQUEST_URLS.DIVAR_INTERNAL_AUTH.COMPARE_FACES,
    REQUEST_URLS.DIVAR_INTERNAL_AUTH.NID_CARD_READER,
    REQUEST_URLS.DIVAR_INTERNAL_AUTH.INIT_CONFIRM,
    REQUEST_URLS.DIVAR_INTERNAL_AUTH.VIDEO_VALIDATION,
    REQUEST_URLS.DIVAR_INTERNAL_AUTH.CREATE_PAYMENT,
    REQUEST_URLS.DIVAR_INTERNAL_AUTH.INQUIRY_PAYMENT,


    //----------Divar FOREIGNER Auth -----------------

    REQUEST_URLS.DIVAR_FOREIGNER_AUTH.CREATE_PROCESS,
    REQUEST_URLS.DIVAR_FOREIGNER_AUTH.INQUIRY_PROCESS,
    REQUEST_URLS.DIVAR_FOREIGNER_AUTH.FETCH_PROCESS,
    REQUEST_URLS.DIVAR_FOREIGNER_AUTH.VIDEO_VALIDATION,
    REQUEST_URLS.DIVAR_FOREIGNER_AUTH.FOREIGNER_DOCUMENT_READER,

    //----------INTEGRATED AUTHENTICATION----------------------
    REQUEST_URLS.INTEGRATED_AUTHENTICATION.CREATE_PAYMENT,
    REQUEST_URLS.INTEGRATED_AUTHENTICATION.SHAHKAR,
    REQUEST_URLS.INTEGRATED_AUTHENTICATION.COMPARE_FACES,
    REQUEST_URLS.INTEGRATED_AUTHENTICATION.PAYMENT_INQUIRY,
    REQUEST_URLS.INTEGRATED_AUTHENTICATION.RESET_PROCESS,
    REQUEST_URLS.INTEGRATED_AUTHENTICATION.FETCH_PROCESS,
    REQUEST_URLS.INTEGRATED_AUTHENTICATION.CREATE_PROCESS,
    REQUEST_URLS.INTEGRATED_AUTHENTICATION.VIDEO_VALIDATION,
    REQUEST_URLS.INTEGRATED_AUTHENTICATION.CONFIRM_IMG,
    REQUEST_URLS.INTEGRATED_AUTHENTICATION.NID_CARD_READER,
    REQUEST_URLS.INTEGRATED_AUTHENTICATION.DELETE_WIDGET,

    //---------FIN CHECK--------------------------------
    REQUEST_URLS.FIN_CHECK.INQUIRY_PROCESS,
    REQUEST_URLS.FIN_CHECK.CREATE_PROCESS,
    REQUEST_URLS.FIN_CHECK.FETCH_PROCESS,
    REQUEST_URLS.FIN_CHECK.INIT_CONFIRM,
    REQUEST_URLS.FIN_CHECK.CREATE_PAYMENT,
    REQUEST_URLS.FIN_CHECK.SHAHKAR,
    REQUEST_URLS.FIN_CHECK.BANKING_OTP_SEND,
    REQUEST_URLS.FIN_CHECK.BANKING_OTP_VERIFY,
    REQUEST_URLS.FIN_CHECK.BACK_CHEQUES_INQUIRY,
    REQUEST_URLS.FIN_CHECK.FACILITY_INQUIRY,
    REQUEST_URLS.FIN_CHECK.RESET_PROCESS,
    REQUEST_URLS.FIN_CHECK.DELETE_WIDGET,
    REQUEST_URLS.FIN_CHECK.PAYMENT_INQUIRY,
    REQUEST_URLS.FIN_CHECK.DISCOUNT,
    //-----------COMPANY APPROVAL --------------------
    REQUEST_URLS.COMPANY_APPROVAL.CREATE_PAYMENT,
    REQUEST_URLS.COMPANY_APPROVAL.CREATE_PROCESS,
    REQUEST_URLS.COMPANY_APPROVAL.FETCH_PROCESS,
    REQUEST_URLS.COMPANY_APPROVAL.DELETE_WIDGET,
    REQUEST_URLS.COMPANY_APPROVAL.SHAHKAR,
    REQUEST_URLS.COMPANY_APPROVAL.INIT_CONFIRM,
    REQUEST_URLS.COMPANY_APPROVAL.INQUIRY_PROCESS,
    REQUEST_URLS.COMPANY_APPROVAL.PAYMENT_INQUIRY,
    REQUEST_URLS.COMPANY_APPROVAL.REQUEST_OTP,
    REQUEST_URLS.COMPANY_APPROVAL.VERIFY_OTP,
    REQUEST_URLS.COMPANY_APPROVAL.RESET_PROCESS,
    REQUEST_URLS.COMPANY_APPROVAL.DISCOUNT,
    REQUEST_URLS.COMPANY_APPROVAL.BUSINESS_LICENSE_INQUIRY,
    REQUEST_URLS.COMPANY_APPROVAL.CONFIRM_BUSINESS,

]
export {ENCRYPTION_URL_LIST}
export default REQUEST_URLS
